const changeActiveMenu = (pageID) => {
  if (!document.getElementById(`menu-${pageID}`)) return;

  const active = document.querySelector('.active');
  active?.classList.remove('active');
  document.getElementById(`menu-${pageID}`).classList.add('active');
};

export default changeActiveMenu;
